import React from 'react'
import { Text } from '@mantine/core'
import { useLotteryData } from '../hooks'

const SideContactService: React.FC = () => {
  const { customerServiceUrl } = useLotteryData()

  if (!customerServiceUrl) {
    return null
  }

  return (
    <a
      href={customerServiceUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        right: 0,
        top: 'calc(16% + 40px)',
        transform: 'translateY(-50%)',
        background: 'linear-gradient(180deg, #4A90E2 0%, #357ABD 100%)',
        borderRadius: '12px 0px 0px 12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100,
        cursor: 'pointer',
        padding: '8px 12px',
        userSelect: 'none',
        boxShadow: '0 3px 12px rgba(74, 144, 226, 0.4)',
        textDecoration: 'none',
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(74, 144, 226, 0.5)'
        e.currentTarget.style.transform = 'translateY(-50%) translateX(-2px)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 3px 12px rgba(74, 144, 226, 0.4)'
        e.currentTarget.style.transform = 'translateY(-50%) translateX(0)'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
        }}
      >
        <Text
          style={{
            color: 'white',
            fontSize: 13,
            fontWeight: 600,
            lineHeight: '16px',
            textAlign: 'left',
            fontStyle: 'normal',
            textTransform: 'none',
            textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
            letterSpacing: '0.3px',
          }}
        >
          联系客服
        </Text>
      </div>

      <div
        style={{
          marginLeft: 8,
          color: 'white',
          fontSize: 12,
          opacity: 0.8,
          lineHeight: 1,
        }}
      >
        💬
      </div>
    </a>
  )
}

export default SideContactService
